<template>
  <div class="home">
    <h1>Confirmação de Agenda</h1> 
  </div>
</template>

<script>

export default {
  name: 'HomeView',
  components: {
    
  }
}
</script>
